import { PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

import { EMPTY_ARRAY, EMPTY_OBJECT } from 'Utils/stableDefaults'

const HUNYUAN_PROVIDERS = [PROVIDER.TENCENT]

/**
 * Resolves the providers switched off for this user by a kill-switch Flipper flag.
 * They are hidden from every flow - model generation and enhancements alike - so
 * no new run can be started with them. Already generated runs are unaffected:
 * openedModelToStatePatch dispatches on providerModelId, not on MODEL_SOURCES, so
 * an old Hunyuan model still opens with its settings and provider label.
 *
 * Like the rollout flags in getHiddenEnhancedProviders, a missing value reads as
 * off: the flag arrives per-user from pageConfig, so Hunyuan stays hidden during
 * the pre-config window and only appears once the real value says it is on. While
 * hidden it cannot take the initial engine slot: a Hunyuan roll from
 * resolveInitialGenerationProvider falls back to the first eligible provider, and
 * setAvailableGenerationProviders keeps that provider active once the real value
 * arrives (0/1/many rules).
 *
 * @param {Object} featureFlags - Flag values from pageConfig.
 * @param {boolean} featureFlags.enableHunyuanProvider
 * @returns {string[]} - Provider ids to hide from every flow.
 */
export const getHiddenProviders = (featureFlags = EMPTY_OBJECT) => {
  const { enableHunyuanProvider = false } = featureFlags

  return enableHunyuanProvider ? EMPTY_ARRAY : HUNYUAN_PROVIDERS
}
